import {inject} from '@angular/core';
import {ResolveFn, Router} from '@angular/router';

export interface ConfirmEmailData {
  verificationTokenPublic: string;
  email: string;
  resend?: boolean;
}

export const confirmEmailResolver: ResolveFn<ConfirmEmailData | null> = () => {
  const router = inject(Router);
  const navigation = router.currentNavigation();
  const state = navigation?.extras.state;

  const verificationTokenPublic = state?.['verificationTokenPublic'] as string | undefined;
  const email = state?.['email'] as string | undefined;
  const resend = state?.['resend'] as boolean | undefined;

  if (!verificationTokenPublic || !email) {
    void router.navigate(['/login']);
    return null;
  }

  return {verificationTokenPublic, email, resend};
};
